import { render } from "./PostOrderView.vue?vue&type=template&id=b1d16fe0"
import script from "./PostOrderView.vue?vue&type=script&lang=js"
export * from "./PostOrderView.vue?vue&type=script&lang=js"

import "./PostOrderView.vue?vue&type=style&index=0&id=b1d16fe0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__